<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
    class="nav-item"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      @click="resetChatCounter(item)"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        :variant="item.tagVariant || 'primary'"
        pill
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import axios from '@/libs/axios'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
  methods: {
    async resetChatCounter(item) {
      if (item.route === 'social-trade') {
        this.$store.commit('app-chat/unreadNotifications', 0)
      }
      // To reset the count of new partner requests created and accepted
      else if (item.route === 'my-partner-requests-list') {
        setTimeout(async () => {
          await axios.get('/partner-request-notification/update-status')
          this.$store.commit('app-chat/unreadRequests', 0)
        }, 10000) // 10 seconds
      }
    },
  },

}
</script>
